<script setup lang="ts">
	// import { VueQueryDevtools } from "@tanstack/vue-query-devtools";
	import {
		MapLibreMap,
		type MapLibreOptions,
	} from "@ptx-autonomous/libs/maplibre";
	import { useLocalStorage } from "@vueuse/core";
	import { provide } from "vue";

	const defaultMapOptions: MapLibreOptions = {
		restoreView: true,
		maxZoom: 20,
		maxRestoredZoom: 18,
	};

	const tractorTurningRadius = useLocalStorage("tractorTurningRadius", {
		feet: 17,
		inches: 0,
	});
	const tractorImplementTurningRadius = useLocalStorage(
		"tractorImplementTurningRadius",
		{ feet: 28, inches: 0 },
	);
	const rearAxleToHitch = useLocalStorage("rearAxleToHitch", {
		feet: 3,
		inches: 10,
	});
	provide("tractorTurningRadius", tractorTurningRadius);
	provide(
		"tractorImplementTurningRadius",
		tractorImplementTurningRadius,
	);
	provide("rearAxleToHitch", rearAxleToHitch);
</script>

<template>
	<!-- <VueQueryDevtools /> -->
	<MapLibreMap
		class="h-full"
		ref="map"
		:options="defaultMapOptions"
	/>
	<router-view />
</template>

<style>
	html,
	body {
		height: 100%;
		width: 100%;
	}
</style>
